import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import InformationLink from './InformationLink'

interface Props {
  employeeId: string
  companyId: string
  legalEntityId: string
}

export const CostCenterLinks = ({ employeeId, companyId, legalEntityId }: Props) => {
  const { navigation } = useNavigation()

  return (
    <>
      <InformationLink
        href={`${navigation.employees.id.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_profile')}
      />
      <InformationLink
        href={`${navigation.settings.finance.costCenters.fullPath()}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_cost_centers')}
      />
    </>
  )
}
